// extracted by mini-css-extract-plugin
export default {"btn-grey":"ModalChangePassword_btn-grey__gIn2Z"};